// Only run on franchise job show pages
const isFranchiseJobShow = window.location.pathname.match(/\/franchise_admin\/franchise_jobs\/\d+$/);

if (isFranchiseJobShow) {
  document.addEventListener('DOMContentLoaded', function () {
    const chargeBtn = document.querySelector('.charge-and-transfer-btn');
    const modalElement = document.getElementById('charge-and-transfer-modal');

    if (chargeBtn && modalElement) {
      chargeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        
        const url = this.dataset.url;
        const details = this.dataset.details;
        
        const modal = modalElement.cloneNode(true);
        modal.style.display = 'block';
        
        const detailsElement = modal.querySelector('.modal-details');
        if (detailsElement) {
          detailsElement.textContent = details;
        }
        
        document.body.appendChild(modal);
        
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      
      function submitForm(actionUrl) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = actionUrl;
        
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'put';
        form.appendChild(methodInput);
        
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        document.body.appendChild(form);
        form.submit();
      }
      
      modal.querySelector('.cancel-transfer-btn').addEventListener('click', function () {
        modal.remove();
      });
      
      modal.querySelector('.confirm-btn').addEventListener('click', function () {
        this.disabled = true;
        this.textContent = 'Executing...';
        submitForm(url);
      });

      const overlay = modal.querySelector('.modal-overlay');
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          modal.remove();
        }
      });
    });
  }
  });
}
